import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login/Login'));
const Privacy = React.lazy(() => import('./views/Pages/Privacy/Privacy'));
const AboutUs = React.lazy(() => import('./views/Pages/AboutUs/AboutUs'));
const Terms = React.lazy(() => import('./views/Pages/TermsAndConditions/TermsAndConditions'));

class App extends Component {

  render() {
    return (
      <Router basename={process.env.REACT_APP_ROUTE_FLAG}>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
            <Route exact path="/privacy-policy" name="Privacy Policy" render={props => <Privacy {...props} />} />
            <Route exact path="/about-us" name="About Us" render={props => <AboutUs {...props} />} />
            <Route exact path="/terms" name="Terms And Conditions" render={props => <Terms {...props} />} />
            <Route path="/" name="Home" render={props => <DefaultLayout {...props} />} />
          </Switch>
        </React.Suspense>
        <ToastContainer autoClose={5000} />
      </Router>
    );
  }
}

export default App;
